import { render, staticRenderFns } from "./AiFileSuggestion.vue?vue&type=template&id=3a2306fd&scoped=true"
import script from "./AiFileSuggestion.vue?vue&type=script&lang=js"
export * from "./AiFileSuggestion.vue?vue&type=script&lang=js"
import style0 from "./AiFileSuggestion.vue?vue&type=style&index=0&id=3a2306fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2306fd",
  null
  
)

export default component.exports